import {Pipe, PipeTransform} from '@angular/core';
import {RaceRegistration, TypeOfRegistration} from "@model";

@Pipe({
    name: 'registrationName',
    standalone: false
})
export class RegistrationNamePipe implements PipeTransform {

  transform(value?: RaceRegistration): string {
    if (!value) return 'Unknown';
    let typeOfRegistration: TypeOfRegistration = RaceRegistration.getTypeOfRegistration(value);

    switch (typeOfRegistration) {
      case TypeOfRegistration.TEAM:
        return this.getTeamRegistrationName(value);
      case TypeOfRegistration.GROUP:
        return this.getGroupRegistrationName(value);
      default:
        return this.getSingleRegistrationName(value);
    }
  }

  private getTeamRegistrationName(value: RaceRegistration): string {
    return "TEAM_NAME";
  }

  private getSingleRegistrationName(value: RaceRegistration): string {
    if (value.competitors && value.competitors.length > 0) {
      return (value.competitors[0].firstName ?? "") + " " + (value.competitors[0].lastName ?? "");
    } else {
      return "SINGLE_REGISTRATION_NAME"
    }
  }

  private getGroupRegistrationName(value: RaceRegistration): string {
    var val: string = "";
    if (value.competitors && value.competitors.length > 0) {
      for (let i = 0; i < value.competitors.length; i++) {
        if (i === 3) break;
        val = val + (value.competitors[i].firstName ?? "") + " " + (value.competitors[i].lastName ?? "");
      }
    } else {
      return "GROUP_REGISTRATION_NAME"
    }
    return val;
  }
}
